import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconExpandHorizontalStyle0 = gravityIconIndividualCss;

const GravityIconExpandHorizontal = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: '5ad24edf73ff731f9c836d09f272bb72718c1d75', color: this.color, size: this.size }, h("svg", { key: 'a560cba892912c219c0d1dd89ef1228408a0c504', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: '35856a79efff7fc0f1350e3d3dfc2b96a27bf020', d: "M15 13.482c0 .444.541.682.887.389l2.93-2.482a.506.506 0 0 0 0-.778l-2.93-2.482c-.346-.293-.887-.055-.887.39v4.963ZM11.25 3a.5.5 0 0 1 .5.5v15a.5.5 0 0 1-.5.5h-.5a.5.5 0 0 1-.5-.5v-15a.5.5 0 0 1 .5-.5h.5ZM6.113 8.129c.346-.293.887-.055.887.39v4.963c0 .444-.541.682-.887.389l-2.93-2.482a.507.507 0 0 1 0-.778l2.93-2.482Z", fill: "currentColor" }))));
    }
};
GravityIconExpandHorizontal.style = GravityIconExpandHorizontalStyle0;

export { GravityIconExpandHorizontal as gravity_icon_expand_horizontal };

//# sourceMappingURL=gravity-icon-expand-horizontal.entry.js.map